// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cprom-cpromWrapper-d687a{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.cprom-cprom-b4826 .cprom-title-wrapper-2bac5 .cprom-title-69537{color:var(--GRAY_2);font-family:PingFangSC-Medium;font-size:16px;font-weight:500;line-height:22px}.cprom-cprom-b4826 .cprom-title-wrapper-2bac5 .cprom-subtitle-fb11a{color:var(--GRAY_5);font-family:PingFangSC-Regular;font-size:12px;font-weight:400;line-height:20px;margin-top:4px}.cprom-cprom-b4826 .cprom-extra-48f1f .cprom-refresh-16b76{margin-right:8px}.cprom-alert-4c64d{margin-bottom:12px}.cprom-alert-4c64d .cprom-content-af6f3{display:flex;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cpromWrapper": "cprom-cpromWrapper-d687a",
	"cprom": "cprom-cprom-b4826",
	"title-wrapper": "cprom-title-wrapper-2bac5",
	"titleWrapper": "cprom-title-wrapper-2bac5",
	"title": "cprom-title-69537",
	"subtitle": "cprom-subtitle-fb11a",
	"extra": "cprom-extra-48f1f",
	"refresh": "cprom-refresh-16b76",
	"alert": "cprom-alert-4c64d",
	"content": "cprom-content-af6f3"
};
export default ___CSS_LOADER_EXPORT___;
